module.exports = __webpack_public_path__ + "img/lotus-colored.767b5a58.svg";